<div class="search-box">
  <input type="search" name="search" id="search" #inputSearch [value]="key" (keyup)="filterAddress($event)" [placeholder]="'Search' | translate">
</div>